var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleDownIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#102A56",
  d: "M.5 9.646a8.5 8.5 0 1 0 17 0 8.5 8.5 0 0 0-17 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#102A56",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m12.47 7.587-3.44 3.439-3.438-3.44"
})));
export default SvgCircleDownIcon;